/**
 * The three programs, as the app's catalogue states them. This is a COPY:
 * the landing cannot import the app's source, so src/__tests__/facts.test.js
 * reads src/training/content/programs/*.js at the repository root and fails
 * when a name, tier, length, bell rule or summary here stops matching.
 * Change the catalogue first, then this file.
 */
const programs = [
  {
    id: 'foundations',
    name: 'Foundations',
    tier: 'free',
    weeks: 6,
    equipmentRule: 'one-bell',
    summary:
      'Learn the swing, the deadlift, the squat, the press and the get-up with one bell, three short sessions a week.',
  },
  {
    id: 'full-body-strength',
    name: 'Full Body Strength',
    tier: 'pro',
    weeks: 8,
    equipmentRule: 'one-or-two-bells',
    summary:
      'Eight weeks of squats, presses, hinges, rows and carries that build from more sets to heavier bells, with a deload in week four.',
  },
  {
    id: 'kettlebell-conditioning',
    name: 'Kettlebell Conditioning',
    tier: 'pro',
    weeks: 6,
    equipmentRule: 'one-bell',
    summary:
      'Six weeks of EMOMs, intervals, AMRAPs and ladders with one bell, bookended by a ten-minute swing test.',
  },
];

export const BELL_RULE_LABEL = {
  'one-bell': 'One bell',
  'one-or-two-bells': 'One or two bells',
};

export default programs;
